import { RootState } from '../../../app';

export const selectIsLoadingContactSupport = ({
  contactSupportForm,
}: RootState) => contactSupportForm.isLoadingContactSupport;
